import { z } from "zod"

export const webhookSchema = z.object({
  url: z
    .string()
    .url("Please enter a valid URL")
    .startsWith("https://", "URL must start with https://")
    .min(1, "URL is required"),
  secret: z
    .string()
    .min(16, "Secret must be at least 16 characters")
    .max(64, "Secret must not exceed 64 characters")
    .regex(/^[a-zA-Z0-9]+$/, "Secret must only contain letters and numbers"),
})
